import Cookies from 'universal-cookie'

const isProd = process.env.NODE_ENV === 'production'

const cookies = new Cookies(null, {
  path: '/',
  secure: isProd,
  maxAge: 60 * 60 * 24 * 30,
  sameSite: isProd ? 'lax' : 'strict',
  domain: isProd ? '.aicade.io' : undefined,
})

export default cookies
